import React, { useEffect } from 'react';
import { withRouter } from "react-router-dom";
import { Button, Card, Divider, Typography, useFormValidation } from "../ecosystem";
import { Typeahead } from "../ecosystem/mybswh";
import FindCareButton from './FindCareButton';
import { translateText } from '../../helpers/data';
import { withTranslation } from 'react-i18next';

const FindCareSearchForm = ({
    borderStyle = "elevated",
    className,
    isValid,
    keywordInputProps,
    locationInputProps,
    insuranceInputProps,
    submitButtonProps,
    translate,
    t
}) => {

    const keywordInputName = keywordInputProps?.name ? keywordInputProps?.name : "careKeyword";
    const locationInputName = locationInputProps?.name ? locationInputProps?.name : "cityOrZip";
    const insuranceInputName = insuranceInputProps?.name ? insuranceInputProps?.name : "insurance";

    const validationRules = {
        [keywordInputName]: {
            required: {
                value: keywordInputProps?.required,
                message: keywordInputProps?.inputErrorMsg
            },
            custom: {
                isValid: keywordInputProps?.isValid,
                message: keywordInputProps?.customErrorMsg
            }
        },
        [locationInputName]: {
            required: {
                value: locationInputProps?.required,
                message: locationInputProps?.inputErrorMsg
            },
            custom: {
                isValid: locationInputProps?.isValid,
                message: locationInputProps?.customErrorMsg
            }
        },
        [insuranceInputName]: {
            required: {
                value: insuranceInputProps?.required,
                message: insuranceInputProps?.inputErrorMsg
            },
            custom: {
                isValid: insuranceInputProps?.isValid,
                message: insuranceInputProps?.customErrorMsg
            }
        },
        form: {
            isValid: isValid,
            message: "Enter a valid search term"
        }
    };

    const { handleInput, formErrors, handleForm, } = useFormValidation({
        initialValues: {
            [keywordInputName]: keywordInputProps?.value,
            [locationInputName]: locationInputProps?.value,
            [insuranceInputName]: insuranceInputProps?.value,
        },
        validations: validationRules
    });

    // Triggering validation with useEffect since using onChange directly on input causes issues with typeahead
    useEffect(() => {
        handleInput(null, {
            name: keywordInputName,
            value: keywordInputProps?.value
        });
    }, [keywordInputProps?.value]);

    useEffect(() => {
        handleInput(null, {
            name: locationInputName,
            value: locationInputProps?.value
        });
    }, [locationInputProps?.value, locationInputProps?.customErrorMsg]); //CustomErrorMsg for geolocation error

    useEffect(() => {
        handleInput(null, {
            name: insuranceInputName,
            value: insuranceInputProps?.value
        });
    }, [insuranceInputProps?.value]);

    const handleOnBlur = (e, blurFunction) => {
        handleInput(e);

        if (blurFunction) {
            blurFunction(e);
        }
    }

    // Form valid check for input submit
    const isFormValid = () => {
        const formValidObj = handleForm();

        return formValidObj.value;
    }

    // Form submit function for button click
    const handleFormSubmit = (e) => {
        handleForm(e);

        if (submitButtonProps?.onClick) {
            submitButtonProps?.onClick();
        }
    }

    const inputWrapper = (content, className) => <div className={`col find-care-input-wrapper ${className}`}>
        <div className="find-care-tile">
            {content}
        </div>
    </div>;

    return (<form className={`find-care-search-form ${className ? className : ''}`}>
        <Card borderStyle={borderStyle} className={"find-care-search-card"}>
            <div className={"row find-care-search-card-content-container"}>
                {inputWrapper(<>
                    <Typeahead
                        label={translateText(translate, "What care are you looking for?", t)}
                        icon="search"
                        {...keywordInputProps}
                        id={keywordInputProps?.id ? keywordInputProps?.id : keywordInputName}
                        name={keywordInputName}
                        onBlur={(e) => { handleOnBlur(e, keywordInputProps?.onBlur ? keywordInputProps?.onBlur(e) : ''); }}
                        onSelect={(val, item) => { keywordInputProps?.onSelect(val, item, formErrors) }} //Passing formErrors for more selection
                        onSubmitForm={(e) => { keywordInputProps?.onSubmitForm(isFormValid()) }}
                        error={formErrors[keywordInputName]?.value}
                        hintMsg={formErrors[keywordInputName]?.message ? formErrors[keywordInputName]?.message : keywordInputProps?.hintMsg}
                    />
                </>, 'keyword-input-wrapper')}

                <Divider orientation="vertical" />
                {inputWrapper(<>
                    <Typeahead
                        label={translateText(translate, "City or Zip", t)}
                        icon="location"
                        {...locationInputProps}
                        id={locationInputProps?.id ? locationInputProps?.id : locationInputName}
                        name={locationInputName}
                        onBlur={(e) => { handleOnBlur(e, locationInputProps?.onBlur ? locationInputProps?.onBlur(e) : ''); }}
                        onSubmitForm={(e) => { locationInputProps?.onSubmitForm(isFormValid()) }}
                        error={formErrors[locationInputName]?.value || locationInputProps?.geoErrorMsg}
                        hintMsg={formErrors[locationInputName]?.message
                            ? formErrors[locationInputName]?.message 
                            : locationInputProps?.geoErrorMsg
                                ? locationInputProps?.geoErrorMsg
                                : locationInputProps?.hintMsg
                        }
                    />
                </>, 'location-input-wrapper')}

                <Divider orientation="vertical" />
                {inputWrapper(<>
                    <Typeahead
                        label={translateText(translate, "Insurance", t)}
                        icon="insurance"
                        {...insuranceInputProps}
                        id={insuranceInputProps?.id ? insuranceInputProps?.id : insuranceInputName}
                        name={insuranceInputName}
                        onBlur={(e) => { handleOnBlur(e, insuranceInputProps?.onBlur ? insuranceInputProps?.onBlur(e) : ''); }}
                        onSubmitForm={(e) => { insuranceInputProps?.onSubmitForm(isFormValid()) }}
                        error={formErrors[insuranceInputName]?.value}
                        hintMsg={formErrors[insuranceInputName]?.message ? formErrors[insuranceInputName]?.message : insuranceInputProps?.hintMsg}
                    />
                </>, 'insurance-input-wrapper')}

                <div className="col find-care-landing-button">
                    <FindCareButton
                        {...submitButtonProps}
                        translate={translate}
                        onClick={handleFormSubmit}
                    />
                </div>
            </div>
        </Card>
    </form>);
}

export default withRouter(withTranslation()(FindCareSearchForm));
